// extracted by mini-css-extract-plugin
module.exports = {"sm":"1px","md":"2px","lg":"4px"};